import { createStyles, makeStyles } from '@material-ui/styles'
import { fontWeights } from 'shared/style/fonts'
import colors from 'shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    footerSectionTitle: {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      fontSize: '1.1rem',
      marginBottom: 32
    },
    footerSectionTexte: {
      fontSize: '1rem',
      marginBottom: 22,
      fontWeight: 'lighter'
    },
    footerButton: {
      borderColor: '#979797',
      color: '#8E8E93',
      borderStyle: 'solid',
      borderWidth: 1,
      height: 30,
      width: 120
    },
    footerinput: {
      backgroundColor: '#8E8E93',
      color: '#8E8E93',
      height: 30,
      width: '100%',
      border: 'none'
    },
    footerWrapper: {
      padding: '0 0 3rem 0'
    },
    footerTop: {
      marginBottom: '2rem'
    },
    networksImages: {
      margin: '1rem'
    },
    networksImagesAlign: {
      margin: 'calc(1rem + 4px) 1rem 1rem 1rem'
    },
    linksTexte: {
      width: '9.0625rem',
      fontSize: 12,
      color: colors.darkGrey,
      textAlign: 'center',
      '&:hover': {
        fontWeight: fontWeights.bold
      }
    },
    copyrightsTexte: {
      fontSize: 12,
      color: '#8E8E93'
    },
    fondationImage: {
      width: 180
    },
    links: {
      margin: '1rem 0'
    }
  })
)
